import {Box, Typography} from "@mui/material";
import {c, cardSx} from "../landingTokens";
import {Section, Eyebrow, SectionHeading, Dim} from "./Shell";
import {ProductShot} from "./ProductShot";
import supervisionShot from "../../../assets/images/supervision.png";
import dashboardShot from "../../../assets/images/dashboard.png";

const CAPABILITIES = [
  {
    title: "Multilingual & 24/7",
    body: "English, Macedonian, Serbian and Croatian in production — and we train models for any language you need. Zero downtime, no global payroll.",
  },
  {
    title: "Live supervision",
    body: "Every conversation is logged and watchable as it happens. A supervisor can stop the AI mid-call, redirect the caller to an Avaya phone, or dial out from the interface — then leave comments on the transcript that feed straight back into the flow.",
  },
  {
    title: "Customizable workflows",
    body: "Tailor scripts, escalation paths and branding to the way your team already works.",
  },
  {
    title: "Security & compliance",
    body: "GDPR-aligned data handling, EU hosting options, call redaction and full audit trails.",
  },
];

export const Capabilities = () => (
  <Section id="capabilities" label="Capabilities">
    <Eyebrow>Capabilities</Eyebrow>
    <SectionHeading sx={{mb: 6.5, maxWidth: 820}}>
      Powering the future of<br />
      <Dim>contact centers.</Dim>
    </SectionHeading>

    <Box sx={{display: "grid", gridTemplateColumns: {xs: "1fr", sm: "1fr 1fr"}, gap: 2.25}}>
      {CAPABILITIES.map((item) => (
        <Box key={item.title} sx={cardSx}>
          <Typography sx={{fontSize: 24, letterSpacing: "-0.02em", fontWeight: 600, mb: 1.25}}>{item.title}</Typography>
          <Typography sx={{fontSize: 15, lineHeight: 1.55, color: c.inkSoft}}>{item.body}</Typography>
        </Box>
      ))}
    </Box>

    <Box sx={{mt: 2.25, display: "grid", gridTemplateColumns: {xs: "1fr", md: "1.15fr 1fr"}, gap: 2.25}}>
      <ProductShot src={supervisionShot} alt="Live supervision interface" ratio="16 / 10" />
      <ProductShot src={dashboardShot} alt="Analytics dashboard" ratio="16 / 11.6" />
    </Box>
  </Section>
);
